// removed by extract-text-webpack-plugin
module.exports = {"navRow":"Catalog--navRow--2ldBeJjJ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/events/Views/Catalog/Catalog.css
// module id = 1334
// module chunks = 2